import store from '../../../store'
import  organization_filter from './organization_filter.vue'

window.ORG_FILTER=  new Vue({
    store,
    el: '#organization_filter',

    data () {
        return {

        }
    },
    created () {

    },
    components : {
        organization_filter
    }
});
